export default __webpack_public_path__ + "static/media/DSC_5679.45a9654e.jpg";